import Swiper from 'swiper'

class SKSwiper {
	constructor() {
		this._init()
	}
	_init() {
		this.els = document.querySelectorAll('[data-sk-swiper]')
		let options = {
			loop: true,
			draggable: false,
			autoplay: {
				delay: 5000,
			}
		}
		this.els.forEach(element => {
			this.swiper = new Swiper(element, options)
		});
	}
}

export default SKSwiper